import styled from "styled-components";

export const VoucherCardBackHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-content: flex-start;
    ${({theme}) => theme.font.presets.bold};
    font-size: 2.2rem;
    padding-top: 10px;
    padding-bottom: 10px;
`